import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from '../../components/features/dashboard/dashboard.component';
import { SharedModule } from 'src/app/shared.module';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { MenuModule } from 'primeng/menu';
import { ConnectionRequestComponent } from '../../components/features/dashboard/connection-request/connections-request.component';
import { NoResultsOpportunitiesComponent } from '../../components/features/dashboard/no-results-opportunities/no-results-opportunities.component';
import { NoResultsProjectsComponent } from '../../components/features/dashboard/no-results-projects/no-results-projects.component';
import { BadgeModule } from 'primeng/badge';
import {
  FileHistoryListModalModule,
  MessagingModule,
  SustainmentButtonModule,
  ProjectLimitPopoverModule,
  ProjectModule
} from 'sustainment-component';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ChipModule } from 'primeng/chip';
import { SignNdaComponent } from 'src/app/components/features/dashboard/sign-nda/sign-nda.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProjectInviteRequestComponent } from '../../components/features/dashboard/project-invitation-request/project-invitation-request.component';
import { CertificationUpdateRequestComponent } from 'src/app/components/features/dashboard/certification-update-request/certification-update-request.component';
import { ProjectCommunityRequestComponent } from 'src/app/components/features/dashboard/community-requet/project-community-request.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TopNotificationsScrollDirective } from 'src/app/components/features/dashboard/top-notifications-scroll.directive';
import { ChatSearchComponent } from '../../components/features/dashboard/chat-search/chat-search.component';
import { RouterModule } from '@angular/router';
import { SupplierEmailConfirmationComponent } from 'src/app/components/features/dashboard/supplier-email-confirmation/supplier-email-confirmation.component';
import { ConfirmEmailModalComponent } from 'src/app/components/features/dashboard/supplier-email-confirmation/modal/confirm-email-modal.component';
import { ProjectsContainerModule } from '../projects/projects.module';
import { ProjectMemberStatusSelectorComponent } from 'src/app/components/ui/project-member-status-selector/project-member-status-selector.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ConnectionRequestComponent,
    SignNdaComponent,
    ProjectInviteRequestComponent,
    ProjectCommunityRequestComponent,
    NoResultsOpportunitiesComponent,
    NoResultsProjectsComponent,
    CertificationUpdateRequestComponent,
    TopNotificationsScrollDirective,
    ChatSearchComponent,
    SupplierEmailConfirmationComponent,
    ConfirmEmailModalComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    SustainmentButtonModule,
    PanelModule,
    AccordionModule,
    BadgeModule,
    MessagingModule,
    MenuModule,
    DialogModule,
    FileHistoryListModalModule,
    OverlayPanelModule,
    ProjectLimitPopoverModule,
    ChipModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    RouterModule,
    ProjectModule,
    ProjectsContainerModule,
    ProjectMemberStatusSelectorComponent
  ],
  exports: [DashboardComponent]
})
export class DashboardModule {}
